import { render } from "./Coachmark.vue?vue&type=template&id=cace2670&scoped=true"
import script from "./Coachmark.vue?vue&type=script&lang=js"
export * from "./Coachmark.vue?vue&type=script&lang=js"

import "./Coachmark.vue?vue&type=style&index=0&id=cace2670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cace2670"]])

export default __exports__